import { Component } from '@angular/core';
import { DxScrollViewModule } from 'devextreme-angular';

@Component({
  selector: 'app-scroll-view-with-bottom-bar',
  template: `
    <div style="display: flex; justify-content: flex-start; align-items: flex-end;">
      <dx-scroll-view
        width="100%"
        class="scroll-view-footer-bar-after"
      >
        <ng-content></ng-content>
      </dx-scroll-view>
    </div>
    <div class="scroll-view-footer-bar button-bar">
      <ng-content select="div.bottom-bar"></ng-content>
    </div>
  `,
  imports: [DxScrollViewModule],
})
export class ScrollViewWithBottomBarComponent {}
